module.exports = __webpack_public_path__ + "img/reference33.8dfd1993.jpg";